exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-you{\r\n\tmin-width: 100%;\r\n\twidth: 100%;\r\n\tmax-width: 100%;\r\n\tmax-height: 200px;\r\n\tmin-height: 54px;\r\n}\r\n.services-inquiring{\r\n\tmargin-bottom: -16px;\r\n\tmargin-top: 16px;\r\n}\r\n.required .required-text {\r\n    visibility: hidden;\r\n    width: 120px;\r\n    background-color: black;\r\n    color: #fff;\r\n    text-align: center;\r\n    border-radius: 6px;\r\n    padding: 5px 0;\r\n    \r\n    /* Position the required */\r\n    position: absolute;\r\n    z-index: 1;\r\n    bottom: 100%;\r\n    left: 50%;\r\n    margin-left: -60px;\r\n}\r\n\r\n.required:hover .required-text {\r\n    visibility: visible;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/GitHub/gvrogers/src/app/styles/contact-us.component.css
// module id = ../../../../../src/app/styles/contact-us.component.css
// module chunks = 1